/* MAKSU theme — vanilla JS, no dependencies.
   Drawers, sticky header, variant picker, gallery, Ajax cart, filters, predictive search, sliders, reveal.
   Motion follows MOTION.md (Heritage Olive): quiet fades, 70ms stagger, no bounce. */
(function () {
  'use strict';

  var T = window.theme || {};
  var body = document.body;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function debounce(fn, wait) {
    var t;
    return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var format = T.moneyFormat || '${{amount}}';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  var toastTimer;
  function toast(msg) {
    var t = $('.toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  // Replace a section's content with fresh HTML from the Section Rendering API.
  function replaceSection(id, html) {
    var current = document.getElementById('shopify-section-' + id);
    if (!current || !html) return;
    var fresh = parseHTML(html).getElementById('shopify-section-' + id);
    if (fresh) { current.innerHTML = fresh.innerHTML; init(current); }
  }

  /* ---------- overlays: mobile menu, cart drawer, filter drawer ---------- */
  var lastFocus = null;
  function openOverlay(name) {
    closeOverlays(true);
    var panel = document.getElementById(name === 'cart' ? 'cart-drawer' : name === 'menu' ? 'mobile-menu' : 'filter-drawer');
    if (!panel) return false;
    lastFocus = document.activeElement;
    body.classList.add(name + '-open');
    setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
    return true;
  }
  function closeOverlays(silent) {
    var wasOpen = /(cart|menu|filter)-open/.test(body.className);
    body.classList.remove('cart-open', 'menu-open', 'filter-open');
    if (wasOpen && !silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var name = opener.getAttribute('data-open');
      if (openOverlay(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeOverlays(); return; }
    if (e.target.closest('[data-close-on-click]')) closeOverlays(true);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlays();
    if (e.key !== 'Tab') return;
    var open = body.classList.contains('cart-open') ? $('#cart-drawer') : body.classList.contains('menu-open') ? $('#mobile-menu') : body.classList.contains('filter-open') ? $('#filter-drawer') : null;
    if (!open) return;
    var f = $$('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', open).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === open)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- sticky header border ---------- */
  var onScroll = function () {
    var h = $('.header');
    if (!h) return;
    // Two thresholds: the header shrinks when it sticks, which moves the page by ~10px; one threshold made it flip back and forth
    var y = window.scrollY, on = h.classList.contains('is-stuck');
    if (!on && y > 80) h.classList.add('is-stuck');
    else if (on && y < 20) h.classList.remove('is-stuck');
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- quantity steppers (product + cart) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty] [data-step]');
    if (!btn) return;
    var input = $('input', btn.closest('[data-qty]'));
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-step'), 10));
    if (String(next) === input.value) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart API ---------- */
  function cartSections() {
    var ids = ['cart-icon-bubble'];
    if ($('#cart-drawer')) ids.push('cart-drawer');
    var main = $('[data-main-cart]');
    if (main) ids.push(main.getAttribute('data-section-id'));
    return ids;
  }

  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = parseHTML(html);
      if (id === 'cart-icon-bubble') {
        var fresh = $('[data-cart-count]', doc);
        $$('[data-cart-count]').forEach(function (c) {
          if (!fresh) return;
          c.textContent = fresh.textContent;
          c.hidden = fresh.hidden;
          if (!reduceMotion) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
        });
      } else if (id === 'cart-drawer') {
        var drawer = $('#cart-drawer'), next = $('#cart-drawer', doc);
        if (drawer && next) drawer.innerHTML = next.innerHTML;
      } else {
        replaceSection(id, html);
      }
    });
  }

  function cartRequest(url, payload) {
    payload.sections = cartSections();
    payload.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) { var err = new Error(data.description || data.message || T.strings.error); err.data = data; throw err; }
        return data;
      });
    });
  }

  function afterAdd(data) {
    if (T.cartType === 'page' || !$('#cart-drawer')) { window.location.href = T.routes.cart; return; }
    renderCartSections(data.sections);
    openOverlay('cart');
  }

  // product forms: main product, featured product, quick add
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var submitter = e.submitter && e.submitter.hasAttribute('data-add-button') ? e.submitter : $('[type=submit]', form);
    if (!submitter || submitter.disabled) return;
    var idInput = form.querySelector('[name=id]');
    var qtyInput = form.querySelector('[name=quantity]');
    var items = [{ id: parseInt(idInput.value, 10), quantity: Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1) }];
    var root = form.closest('[data-product]');
    var addon = root && $('[data-addon]:not([hidden]) input:checked', root);
    if (addon) items.push({ id: parseInt(addon.getAttribute('data-addon-id'), 10), quantity: 1 });
    var errorBox = $('[data-form-error]', form);
    if (errorBox) errorBox.hidden = true;
    submitter.classList.add('is-loading');
    submitter.setAttribute('aria-busy', 'true');
    cartRequest(T.routes.cartAdd + '.js', { items: items })
      .then(function (data) {
        afterAdd(data);
        if (addon) addon.checked = false;
      })
      .catch(function (err) {
        if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; } else { toast(err.message); }
      })
      .finally(function () { submitter.classList.remove('is-loading'); submitter.removeAttribute('aria-busy'); });
  });

  // cart line quantity / remove, add-on, note (drawer + cart page)
  var pendingLine = {};
  function changeLine(line, qty, origin) {
    var scope = origin && origin.closest('#cart-drawer, [data-main-cart]');
    var el = scope && $('[data-line="' + line + '"]', scope);
    if (el) el.classList.add('is-updating');
    cartRequest(T.routes.cartChange + '.js', { line: line, quantity: qty })
      .then(function (data) { renderCartSections(data.sections); })
      .catch(function (err) {
        if (el) el.classList.remove('is-updating');
        var msg = scope && $('[data-line-error="' + line + '"]', scope);
        if (msg) { msg.textContent = err.message; msg.hidden = false; } else toast(err.message);
      });
  }
  document.addEventListener('change', function (e) {
    var q = e.target.closest('[data-line-qty]');
    if (q) {
      var line = parseInt(q.getAttribute('data-line-qty'), 10);
      clearTimeout(pendingLine[line]);
      pendingLine[line] = setTimeout(function () { changeLine(line, Math.max(0, parseInt(q.value, 10) || 0), q); }, 350);
      return;
    }
    var addon = e.target.closest('[data-cart-addon]');
    if (addon && addon.checked) {
      addon.disabled = true;
      cartRequest(T.routes.cartAdd + '.js', { items: [{ id: parseInt(addon.getAttribute('data-cart-addon'), 10), quantity: 1 }] })
        .then(function (data) { renderCartSections(data.sections); })
        .catch(function (err) { addon.checked = false; addon.disabled = false; toast(err.message); });
    }
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    changeLine(parseInt(rm.getAttribute('data-line-remove'), 10), 0, rm);
  });
  document.addEventListener('input', debounce(function (e) {
    if (!e.target.matches || !e.target.matches('[data-cart-note]')) return;
    fetch(T.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
  }, 500));

  /* ---------- product: variant picker + gallery ---------- */
  function initProduct(root) {
    if (root.__init) return;
    root.__init = true;
    var jsonEl = $('[data-product-json]', root);
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { variants = []; }
    var section = root.closest('[data-product-section]') || root.parentNode;
    var groups = $$('[data-option-group]', root);
    var idInput = $('[data-variant-input]', root);
    var isMainProduct = !!root.closest('.section-main-product');

    function selected() {
      return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
    }
    function setChecked(options) {
      groups.forEach(function (g, i) {
        $$('input', g).forEach(function (inp) { inp.checked = inp.value === options[i]; });
      });
    }
    function findVariant(options) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === options[i]; }); });
    }
    function bestFor(changedIndex, options) {
      var candidates = variants.filter(function (v) { return v.options[changedIndex] === options[changedIndex]; });
      candidates.sort(function (a, b) {
        function score(v) {
          var s = 0;
          for (var i = 0; i < changedIndex; i++) if (v.options[i] === options[i]) s += 100;
          for (var j = changedIndex + 1; j < options.length; j++) if (v.options[j] === options[j]) s += 10;
          if (v.available) s += 5;
          return s;
        }
        return score(b) - score(a);
      });
      return candidates[0];
    }

    // Hide option groups that have a single possible value for the current higher-level choice
    // (e.g. Color is hidden for "Battle Set"), and strike through sold-out values.
    function refreshGroups(options) {
      groups.forEach(function (g, j) {
        var matching = variants.filter(function (v) {
          for (var k = 0; k < j; k++) if (v.options[k] !== options[k]) return false;
          return true;
        });
        var values = {};
        matching.forEach(function (v) { values[v.options[j]] = values[v.options[j]] || v.available; });
        if (j > 0) g.hidden = Object.keys(values).length <= 1;
        $$('input', g).forEach(function (inp) {
          var label = inp.closest('.opt, .swatch');
          if (!label) return;
          var exists = Object.prototype.hasOwnProperty.call(values, inp.value);
          label.hidden = j > 0 && !exists;
          label.classList.toggle('is-unavailable', exists && !values[inp.value]);
        });
      });
    }

    function update(variant) {
      if (!variant) {
        $$('[data-add-button]', section).forEach(function (b) { b.disabled = true; b.textContent = T.strings.unavailable; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      var dips = $$('[data-price]', section);
      dips.forEach(function (el) { el.classList.add('is-dip'); });
      setTimeout(function () { dips.forEach(function (el) { el.classList.remove('is-dip'); }); }, reduceMotion ? 0 : 150);
      $$('[data-price-current]', section).forEach(function (el) { el.textContent = formatMoney(variant.price); });
      $$('[data-price-compare]', section).forEach(function (el) {
        var on = variant.compare_at_price > variant.price;
        el.hidden = !on;
        el.textContent = on ? formatMoney(variant.compare_at_price) : '';
      });
      $$('[data-price-save]', section).forEach(function (el) {
        var on = variant.compare_at_price > variant.price;
        el.hidden = !on;
        if (on) el.textContent = (T.strings.save || 'Save') + ' ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
      });
      $$('[data-add-button]', section).forEach(function (b) {
        b.disabled = !variant.available;
        b.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      });
      var st = $('[data-sticky-title]', section);
      if (st) st.textContent = variant.title === 'Default Title' ? st.textContent : variant.title;
      $$('[data-addon]', root).forEach(function (a) {
        var inp = $('input', a);
        a.hidden = inp && parseInt(inp.getAttribute('data-addon-id'), 10) === variant.id;
      });
      if (variant.featured_media) showMedia(variant.featured_media.id, true);
      if (isMainProduct && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    groups.forEach(function (g, i) {
      g.addEventListener('change', function () {
        var opts = selected();
        var v = findVariant(opts) || bestFor(i, opts);
        if (v) setChecked(v.options);
        refreshGroups(v ? v.options : opts);
        update(v);
      });
    });
    if (groups.length) {
      var cur = findVariant(selected());
      refreshGroups(cur ? cur.options : selected());
    }

    // gallery
    var track = $('[data-gallery-track]', root);
    var slides = $$('.gallery__slide', root);
    var dots = $$('.gallery__dots i', root);
    var thumbs = $$('[data-thumb]', root);
    var thumbsWrap = $('.gallery__thumbs', root);
    var counter = $('[data-gallery-counter]', root);
    var prevBtn = $('[data-gallery-prev]', root);
    var nextBtn = $('[data-gallery-next]', root);
    var mobile = window.matchMedia('(max-width: 989px)');

    function markActive(idx) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); if (!mobile.matches) s.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      slides.forEach(function (s, i) { $$('video', s).forEach(function (v) { if (i === idx) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
      var tb = thumbs[idx];
      if (tb && thumbsWrap && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
        var left = tb.offsetLeft - (thumbsWrap.clientWidth - tb.offsetWidth) / 2;
        thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    function step(delta) {
      if (!slides.length) return;
      var cur = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (cur < 0) cur = 0;
      var next = (cur + delta + slides.length) % slides.length;
      showMedia(slides[next].getAttribute('data-media-id'), true);
    }
    function showMedia(mediaId, fromVariant) {
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx < 0) return;
      if (mobile.matches && track) {
        track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: fromVariant && !reduceMotion ? 'smooth' : 'auto' });
      }
      markActive(idx);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    if (slides.length > 1) markActive(Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); })));
    // Autoplay the video in the active slide: browsers often ignore the attribute until the media is ready
    // or until the first user gesture (iOS Low Power Mode), so retry on both.
    function playActiveVideo() {
      var v = $('.gallery__slide.is-active video', root);
      if (!v || !v.paused) return;
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    $$('video', root).forEach(function (v) {
      v.addEventListener('loadedmetadata', playActiveVideo, { once: true });
      v.addEventListener('canplay', playActiveVideo, { once: true });
    });
    playActiveVideo();
    ['touchstart', 'scroll', 'click', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, playActiveVideo, { once: true, passive: true });
    });
    // Browsers pause media when the tab goes to the background; resume when the visitor comes back.
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') playActiveVideo(); });
    if (track) {
      track.addEventListener('scroll', debounce(function () {
        if (!mobile.matches) return;
        var idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        markActive(Math.min(idx, slides.length - 1));
      }, 60), { passive: true });
    }

    // sticky add-to-cart bar (mobile): shows once the main button scrolls out of view
    var atcRow = $('[data-atc-row]', root);
    var bar = $('[data-sticky-atc]', section);
    if (atcRow && bar && 'IntersectionObserver' in window) {
      var wantBar = false, footerIn = false;
      var paintBar = function () {
        var show = wantBar && !footerIn;   // the bar steps aside once the footer comes into view
        bar.classList.toggle('show', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', bar).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      };
      new IntersectionObserver(function (entries) {
        wantBar = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        paintBar();
      }).observe(atcRow);
      var footerEl = document.querySelector('.footer');
      if (footerEl) new IntersectionObserver(function (entries) { footerIn = entries[0].isIntersecting; paintBar(); }).observe(footerEl);
    }
  }

  /* ---------- sliders (scroll-snap + arrows) ---------- */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-slider] [data-dir]');
    if (!arrow) return;
    var track = $('.slider', arrow.closest('[data-slider]'));
    if (!track || !track.firstElementChild) return;
    track.scrollBy({ left: parseInt(arrow.getAttribute('data-dir'), 10) * (track.firstElementChild.offsetWidth + 16) * 2, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ---------- videos: play muted only while visible ---------- */
  var videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting && !reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
    });
  }, { threshold: 0.25 }) : null;

  /* ---------- reveal on scroll (fade up 16px, staggered 70ms per item inside a section, once) ---------- */
  var revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); revealObserver.unobserve(en.target); } });
  }, { threshold: 0.15 }) : null;

  // Sections that re-render their own content (product, collection, cart) and the first section on the page never animate.
  var REVEAL_SKIP = '[data-product-section], [data-collection-section], [data-main-cart], .section-header, .section-footer, .section-announcement';
  var REVEAL_TARGETS = '.container > *, .split > *, .stack > *, .stack-sm > *, .stack-lg > *, .grid > *, .grid-2 > *, .slider > *, .row > .stack-sm > *, .spec';
  function prepareReveals(scope) {
    if (!revealObserver || reduceMotion || body.classList.contains('shopify-design-mode')) return;
    var sections = $$('#MainContent > .shopify-section');
    sections.forEach(function (sec, idx) {
      if (sec.__revealed || idx === 0 || sec.matches(REVEAL_SKIP) || sec.querySelector(REVEAL_SKIP)) return;
      sec.__revealed = true;
      $$('.reveal', sec).forEach(function (el) { if (!el.closest('.slider')) el.classList.remove('reveal'); });
      var all = $$(REVEAL_TARGETS, sec);
      var leaves = all.filter(function (t) { return !all.some(function (o) { return o !== t && t.contains(o); }); });
      var slot = 0;
      leaves.forEach(function (el) {
        if (el.matches('script, style, template, [hidden], .trail') || el.closest('.drawer, .predictive')) return;
        el.classList.add('reveal');
        if (el.matches('.spec')) el.classList.add('reveal--right');
        el.style.transitionDelay = Math.min(slot * 70, 420) + 'ms';
        slot++;
      });
    });
  }

  // Testimonials: cards away from the centre of the row sit slightly smaller (MOTION.md §8)
  function initReviewScale(scope) {
    if (reduceMotion) return;
    $$('.slider', scope).forEach(function (track) {
      if (track.__scaled || !track.querySelector('.review')) return;
      track.__scaled = true;
      var ticking = false;
      function measure() {
        ticking = false;
        var box = track.getBoundingClientRect(), mid = box.left + box.width / 2;
        $$('.review', track).forEach(function (card) {
          var r = card.getBoundingClientRect();
          card.classList.toggle('is-offcenter', Math.abs(r.left + r.width / 2 - mid) > box.width * 0.34);
        });
      }
      function onMove() { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }
      track.addEventListener('scroll', onMove, { passive: true });
      window.addEventListener('resize', onMove);
      measure();
    });
  }

  /* ---------- product recommendations ---------- */
  function initRecommendations(el) {
    if (el.__init) return;
    el.__init = true;
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = $('[data-recommendations]', parseHTML(html));
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; init(el); }
      })
      .catch(function () {});
  }

  /* ---------- collection filters (Section Rendering API) ---------- */
  function filterUrl(section, params) {
    var q = params.toString();
    return window.location.pathname + (q ? '?' + q : '');
  }
  function renderCollection(section, url, push) {
    var id = section.getAttribute('data-section');
    var grid = $('[data-grid]', section);
    if (grid) grid.classList.add('is-loading');
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + id;
    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var keepOpen = body.classList.contains('filter-open');
        replaceSection(id, html);
        if (keepOpen) body.classList.add('filter-open');
        if (push) window.history.pushState({ collection: true }, '', url);
      })
      .catch(function () { window.location.href = url; });
  }
  function formParams(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) { if (value !== '') params.append(key, value); });
    return params;
  }
  document.addEventListener('change', function (e) {
    var section = e.target.closest('[data-collection-section]');
    if (!section) return;
    var form = $('[data-filter-form]', section);
    if (e.target.matches('[data-sort]') && !form) {
      var p = new URLSearchParams(window.location.search);
      p.set('sort_by', e.target.value);
      p.delete('page');
      renderCollection(section, filterUrl(section, p), true);
      return;
    }
    if (form && (form.contains(e.target) || e.target.matches('[data-sort]'))) {
      if (e.target.type === 'number') return; // handled on input (debounced)
      renderCollection(section, filterUrl(section, formParams(form)), true);
    }
  });
  document.addEventListener('input', debounce(function (e) {
    if (!e.target.matches || !e.target.matches('[data-filter-form] input[type=number]')) return;
    var section = e.target.closest('[data-collection-section]');
    renderCollection(section, filterUrl(section, formParams(e.target.form)), true);
  }, 700));
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-filter-form]');
    if (!form) return;
    e.preventDefault();
    var section = form.closest('[data-collection-section]');
    renderCollection(section, filterUrl(section, formParams(form)), true);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-collection-section] a[data-filter-link]');
    if (!a) return;
    e.preventDefault();
    renderCollection(a.closest('[data-collection-section]'), a.getAttribute('href'), true);
    var top = a.closest('[data-collection-section]').getBoundingClientRect().top + window.scrollY - 90;
    if (a.closest('.pagination')) window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.collection) window.location.reload();
  });

  /* ---------- predictive search ---------- */
  function initPredictive(form) {
    if (form.__init) return;
    form.__init = true;
    var input = $('input[name=q]', form);
    var box = $('[data-predictive-results]', form);
    if (!input || !box || !T.routes.predictiveSearch) return;
    var controller;
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = T.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,vendor';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = parseHTML(html).getElementById('shopify-section-predictive-search');
          box.innerHTML = fresh ? fresh.innerHTML : '';
          box.hidden = !box.innerHTML.trim();
          input.setAttribute('aria-expanded', box.hidden ? 'false' : 'true');
        })
        .catch(function () {});
    }, 250);
    input.addEventListener('input', run);
    input.addEventListener('keydown', function (e) {
      var items = $$('a', box);
      if (box.hidden || !items.length) return;
      var i = items.findIndex(function (a) { return a.getAttribute('aria-selected') === 'true'; });
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (i > -1) items[i].setAttribute('aria-selected', 'false');
        i = e.key === 'ArrowDown' ? (i + 1) % items.length : (i - 1 + items.length) % items.length;
        items[i].setAttribute('aria-selected', 'true');
        items[i].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && i > -1) {
        e.preventDefault(); window.location.href = items[i].href;
      } else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }

  /* ---------- init (runs on load and when the theme editor reloads a section) ---------- */

  // Language switcher
  function initLang(scope){
    (scope || document).querySelectorAll('[data-lang]').forEach(function(box){
      if (box.dataset.langReady) return;
      box.dataset.langReady = '1';
      var btn = box.querySelector('[data-lang-toggle]');
      var list = box.querySelector('.lang__list');
      if (!btn || !list) return;
      btn.addEventListener('click', function(){
        var open = list.hasAttribute('hidden');
        if (open) { list.removeAttribute('hidden'); } else { list.setAttribute('hidden',''); }
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function(e){
        if (!box.contains(e.target)) { list.setAttribute('hidden',''); btn.setAttribute('aria-expanded','false'); }
      });
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape') { list.setAttribute('hidden',''); btn.setAttribute('aria-expanded','false'); }
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    $$('[data-product]', scope).forEach(initProduct);
    $$('[data-recommendations]', scope).forEach(initRecommendations);
    $$('[data-predictive-search]', scope).forEach(initPredictive);
    $$('.media video', scope).forEach(function (v) {
      if (v.hasAttribute('controls') || v.__observed) return;
      v.__observed = true;
      if (videoObserver) videoObserver.observe(v);
    });
    initLang(scope);
    prepareReveals(scope);
    initReviewScale(scope);
    $$('.reveal', scope).forEach(function (el) {
      if (el.classList.contains('in')) return;
      if (revealObserver && !reduceMotion && !body.classList.contains('shopify-design-mode')) revealObserver.observe(el);
      else el.classList.add('in');
    });
  }

  /* ---------- lightbox: tap any photo inside [data-lightbox] to see it full-screen ---------- */
  var lightbox = (function () {
    var box, img, counter, prevBtn, nextBtn, items = [], idx = 0, lastFocus = null, touchX = null;
    function fullSrc(el) {
      // The largest candidate in srcset is the sharpest file Shopify has for this photo.
      var ss = el.getAttribute('srcset'), best = null, bw = 0;
      if (ss) ss.split(',').forEach(function (c) { var p = c.trim().split(/\s+/); var w = parseInt(p[1], 10) || 0; if (w > bw) { bw = w; best = p[0]; } });
      return best || el.currentSrc || el.src;
    }
    function build() {
      if (box) return;
      var arrow = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>'; };
      box = document.createElement('div');
      box.className = 'lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', T.strings.photoViewer || 'Photo viewer');
      box.innerHTML =
        '<button type="button" class="icon-btn lightbox__close" data-lb-close aria-label="' + (T.strings.closePhoto || 'Close') + '">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<button type="button" class="lightbox__nav lightbox__nav--prev" data-lb-prev aria-label="' + (T.strings.prevPhoto || 'Previous') + '">' + arrow(-1) + '</button>' +
        '<img class="lightbox__img" alt="">' +
        '<button type="button" class="lightbox__nav lightbox__nav--next" data-lb-next aria-label="' + (T.strings.nextPhoto || 'Next') + '">' + arrow(1) + '</button>' +
        '<span class="lightbox__counter" aria-live="polite"></span>';
      body.appendChild(box);
      img = $('.lightbox__img', box); counter = $('.lightbox__counter', box);
      prevBtn = $('[data-lb-prev]', box); nextBtn = $('[data-lb-next]', box);
      $('[data-lb-close]', box).addEventListener('click', close);
      prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
      nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
      box.addEventListener('click', function (e) { if (e.target === box || e.target === img) close(); });
      box.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX; touchX = null;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (!box.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') step(1);
        else if (e.key === 'ArrowLeft') step(-1);
      });
    }
    function show(i) {
      idx = (i + items.length) % items.length;
      var it = items[idx];
      img.src = it.src; img.alt = it.alt;
      if (counter) counter.textContent = (T.strings.photoCounter || '%1 / %2').replace('%1', idx + 1).replace('%2', items.length);
      // Warm the neighbours so arrows and swipes feel instant.
      [1, -1].forEach(function (d) { var n = items[(idx + d + items.length) % items.length]; if (n && n !== it) { var pre = new Image(); pre.src = n.src; } });
    }
    function open(list, i) {
      if (!list.length) return;
      build();
      items = list;
      if (items.length > 1) box.removeAttribute('data-single'); else box.setAttribute('data-single', '');
      lastFocus = document.activeElement;
      show(i);
      body.classList.add('lightbox-open');
      box.classList.add('is-open');
      $('[data-lb-close]', box).focus();
    }
    function close() {
      if (!box) return;
      box.classList.remove('is-open');
      body.classList.remove('lightbox-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function step(d) { if (items.length > 1) show(idx + d); }
    document.addEventListener('click', function (e) {
      var el = e.target.closest('img');
      if (!el) return;
      var group = el.closest('[data-lightbox]');
      if (!group || el.closest('a, button, .gallery__thumbs, .lightbox')) return;
      var imgs = $$('.media > img', group).filter(function (im) { return !im.closest('a, button, .gallery__thumbs') && im.offsetParent !== null; });
      if (imgs.indexOf(el) < 0) imgs = [el];
      e.preventDefault();
      open(imgs.map(function (im) { return { src: fullSrc(im), alt: im.alt || '' }; }), imgs.indexOf(el));
    });
    return { open: open, close: close };
  })();

  if (window.Shopify && window.Shopify.designMode) body.classList.add('shopify-design-mode');
  onScroll();
  init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#mobile-menu') && window.innerWidth < 990) openOverlay('menu');
  });
  document.addEventListener('shopify:section:deselect', function () { closeOverlays(true); });
})();

/* iOS Safari applies :active only when the page has a touch listener; this lets the card frame flash on tap. */
document.addEventListener('touchstart', function () {}, { passive: true });
